angular.module('nv.shared.modals').factory('CreditGapConfirmAddModal', CreditGapConfirmAddModal);

function CreditGapConfirmAddModal($mdDialog) {
  return {
    show(courseCodeWithSectionOfAddition, conflictingStudentCourses, conflictingStudentDiffCourses) {
      const formatCoursesText = courses => {
        const coursesLength = courses.length;
        let text = '';

        if (coursesLength === 1) {
          text = `${courses[0].courseCode}-${courses[0].section}`;
        } else if (coursesLength === 2) {
          text = `${courses[0].courseCode}-${courses[0].section} and ${courses[1].courseCode}-${courses[1].section}`;
        } else if (coursesLength > 2) {
          _.each(courses, (course: any, index: number) => {
            if (index !== coursesLength - 1) {
              text += `${course.courseCode}-${course.section}, `;
            } else {
              text += `and ${course.courseCode}-${course.section}`;
            }
          });
        }

        return text;
      };
      const courseOrCoursesText = conflictingStudentCourses.length > 1 ? 'courses' : 'course';
      const additionOrAdditionsText = conflictingStudentDiffCourses.length > 1 ? 'additions' : 'addition';
      let textContent;

      if (conflictingStudentCourses.length && conflictingStudentDiffCourses.length) {
        // tslint:disable-next-line:max-line-length
        textContent = `Adding ${courseCodeWithSectionOfAddition} may conflict with ${
          conflictingStudentCourses.length
        } ${courseOrCoursesText}, ${formatCoursesText(
          conflictingStudentCourses,
        )}, already on the student's current program. It may also conflict with ${
          conflictingStudentDiffCourses.length
        } scheduled pending ${additionOrAdditionsText}, ${formatCoursesText(
          conflictingStudentDiffCourses,
        )}. Are you sure you want to add it?`;
      } else if (conflictingStudentCourses.length) {
        // tslint:disable-next-line:max-line-length
        textContent = `Adding ${courseCodeWithSectionOfAddition} may conflict with ${
          conflictingStudentCourses.length
        } ${courseOrCoursesText}, ${formatCoursesText(
          conflictingStudentCourses,
        )}, already on the student's current program. Are you sure you want to add it?`;
      } else if (conflictingStudentDiffCourses.length) {
        // tslint:disable-next-line:max-line-length
        textContent = `Adding ${courseCodeWithSectionOfAddition} may conflict with ${
          conflictingStudentDiffCourses.length
        } scheduled pending ${additionOrAdditionsText}, ${formatCoursesText(
          conflictingStudentDiffCourses,
        )}. Are you sure you want to add it?`;
      }

      const confirm = $mdDialog
        .confirm()
        .title('Confirm Add')
        .textContent(textContent)
        .css('credit-gap-confirm-add')
        .ariaLabel('Confirm add modal')
        .ok('ADD')
        .cancel('CANCEL');

      return $mdDialog.show(confirm);
    },
  };
}
